const loaded = {}

export function loadScript(props) {
  const { el, onload, id, src, innerHTML, link, style } = props

  // script has already been loaded
  if (loaded[src] && onload) {
    return onload()
  }

  const script = document.createElement(
    link ? 'link' : style ? 'style' : 'script'
  )
  const e = el || document.head

  if (link) {
    script.rel = 'stylesheet'
    script.type = ' text/css'
    script.href = src
    e.appendChild(script)
    return
  }

  script.async = props.async === undefined ? true : props.async

  script.onload = function load() {
    loaded[src] = true
    if (onload) onload()
  }

  if (id) script.id = id
  if (src) script.src = src
  if (innerHTML) script.innerHTML = innerHTML

  e.appendChild(script)
}

export default loadScript
